import { getCurationTabsVisibility as getCurationTabsVisibilityApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type GetCurationTabsVisibilityServiceRequest,
  GetCurationTabsVisibilityServiceRequestSchema,
  type GetCurationTabsVisibilityServiceResponse,
  GetCurationTabsVisibilityServiceResponseSchema,
} from './get-curation-tabs-visibility.dto';

const isNonProduction = process.env.NODE_ENV !== 'production';

export const getCurationTabsVisibilityService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetCurationTabsVisibilityServiceRequestSchema),
    async (
      request: GetCurationTabsVisibilityServiceRequest,
    ): Promise<GetCurationTabsVisibilityServiceResponse> => {
      const apiResponse = await getCurationTabsVisibilityApi(request);

      // NOTE: 무신사 마이샵 탭 UI 확인을 위한 비프로덕션 목업.
      // 백엔드 응답이 불안정/미구현인 환경에서도 탭을 노출해 QA가 가능하도록 한다.
      if (isNonProduction) {
        return { isVisible: true };
      }

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '큐레이션 탭 노출 여부 조회에 실패했습니다.');
      }

      return {
        isVisible: apiResponse.data.isVisible,
      };
    },
    validateServiceResponse(GetCurationTabsVisibilityServiceResponseSchema),
  ),
);
